import { render, staticRenderFns } from "./MoneyBackRequestsPage.vue?vue&type=template&id=058d9ccc&scoped=true"
import script from "./MoneyBackRequestsPage.vue?vue&type=script&lang=js"
export * from "./MoneyBackRequestsPage.vue?vue&type=script&lang=js"
import style0 from "./MoneyBackRequestsPage.vue?vue&type=style&index=0&id=058d9ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058d9ccc",
  null
  
)

export default component.exports